import React, { Component } from 'react';
import { Audio } from './Widgets/Audio';
import { Link } from 'react-router-dom';
import "./css/MainPage.css";

export class MainPage extends Component {
    // Helper function for clarity
    hasPermission = (perm) => this.props.userPermissions.includes(perm);

    render() {

        // Build an array of available sections based on permissions
        const sections = [];

        if (this.hasPermission(this.props.appPermissions.PICK_SALES_ORDERS)) {
            sections.push(
                <div key="picking">
                    <h2>WMS SO Picking</h2>
                    <Link to="/AssignSOP"><h3>Assign SO</h3></Link>
                    <br/>
                    <Link to="/MoveRepick"><h3>Move Repick</h3></Link>
                    <br />
                    <Link to="/PickSummary"><h3>Pick Summary</h3></Link>
                    <br />
                    <Link to="/SOP"><h3>Sales Order Picking App</h3></Link>
                    <br />
                    <Link to="/SOPSummary"><h3>Tote Order Info</h3></Link>
                    <br />
                </div>
            );
        }

        if (this.hasPermission(this.props.appPermissions.MANAGE_BINS)) {
            sections.push(
                <div key="bins">
                    <h2>Bins</h2>
                    <Link to="/BinPutway"><h3>Bin Putaway</h3></Link>
                    <br />
                </div>
            );
        }

        if (this.hasPermission(this.props.appPermissions.ITEM_LOOKUP)) {
            sections.push(
                <div key="inventory">
                    <h2>Inventory</h2>
                    <Link to="/ItemLookup"><h3>Item Lookup</h3></Link>
                    <br />
                    {this.hasPermission(this.props.appPermissions.EXPIRATION_DATE_MANAGEMENT) && (
                        <>
                            <Link to="/ManageExpiration"><h3>Manage Expiration</h3></Link>
                            <br />
                        </>
                    )}
                    {this.hasPermission(this.props.appPermissions.SUBLOCATION_MANAGEMENT) && (
                        <>
                            <Link to="/ManageSublocations"><h3>Manage Sublocations</h3></Link>
                            <br />
                        </>
                    )}
                </div>
            );
        }

        if (this.hasPermission(this.props.appPermissions.WMS_NAMETAGS)) {
            sections.push(
                <div key="nametags">
                    <h2>WMS Nametags</h2>
                    <Link to="/NametagApproval"><h3>Nametag Approval</h3></Link>
                    <br />
                    <Link to="/NametagReceiving"><h3>Nametag Receiving</h3></Link>
                </div>
            );
        }

        return (
            <div>
                <Audio />
                <div className="wmsApps">
                    <h1>WMS Applications</h1>
                    {sections.length > 0 ? sections : <h2>No Applications Available</h2>}
                </div>
            </div>
        );
    }
}
